export class Consent {
    consentUid: string;
    text: string;
    isChecked: boolean;

    constructor(result: any) {
        this.consentUid = result.consentUid;
        this.isChecked = result.isChecked;
        this.text = result.text;
    }
}
